import { createListSet } from "@/components/List";

export const PostListSet = createListSet();
